/**
 * File to hold all our VueJS global filters
 */

Vue.filter('capitalize', function (value) {
    if (! value) {
        return '';
    }

    value = value.toString();

    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
});

Vue.filter('kebab', function (string) {
    return _.kebabCase(string);
})

Vue.filter('escapeTime', function (escapeSeconds) {
    if (! escapeSeconds) {
        return '';
    }

    if (escapeSeconds == -1) {
        return 'FAILURE';
    }

    if (escapeSeconds > 0) {
      let m = moment.duration({'seconds' : escapeSeconds});
      let min = parseInt(m._data.hours * 60) + parseInt(m._data.minutes);
      min = min < 10 ? '0' + min : min;
      let sec = m._data.seconds < 10 ? '0' + m._data.seconds : m._data.seconds;
      return min + ':' + sec + '.' + Math.floor(m._data.milliseconds/100);
    } else {
      let m = moment.duration({'seconds' : -escapeSeconds});
      let min = parseInt(m._data.hours * 60) + parseInt(m._data.minutes);
      min = min < 10 ? '0' + min : min;
      let sec = m._data.seconds < 10 ? '0' + m._data.seconds : m._data.seconds;
      return '-' + min + ':' + sec + '.' + Math.floor(m._data.milliseconds/100);
    }
});

Vue.filter('truncate', function (str, length, ending) {
    if (str === null) {
        return '';
    }
    if (length == null) {
        length = 100;
    }
    if (ending == null) {
        ending = '...';
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
});

Vue.filter('money', function (value, currencyCode = null) {
  if (value === null) {
    return '';
  }

  if (currencyCode === null) {
    currencyCode = process.env.MIX_MONEY_DEFAULTS_CURRENCY ?? 'GBP';
  }

  return new Intl.NumberFormat('en-GB', {style: 'currency', currency: currencyCode, currencyDisplay: 'narrowSymbol'}).format(value / 100);
});
